import React from "react";

import { MenuItemsList } from "./MenuItemsList";
import MenuItems from "./MenuItems";
const Navbar = ({ productTypes }) => {
  return (
    <nav>
      <ul className="menus">
        {MenuItemsList.map((menu, index) => {
          const depthLevel = 0;

          /* if (menu.url === "/admin/products") {
            for (var i in productTypes) {
              var temp_item = productTypes[i];
              var test = {
                title: temp_item.Type,
                //url: temp_item.url,
              };
              if (
                !menu.submenu.some((item) => item["Type"] === temp_item.Type) &&
                menu.submenu.length < productTypes.length
              ) {
                menu.submenu.push(test);
                console.log("submenu length: " + menu.submenu.length);
              }
            }
          } */
          return <MenuItems items={menu} key={index} depthLevel={depthLevel} />;
        })}
      </ul>
    </nav>
  );
};

export default Navbar;
